import BatchEmailTemplatePreview from "./BatchEmailTemplatePreview"

export default BatchEmailTemplatePreview
